/* eslint-disable
    react/prop-types
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import React from 'react';

import createReactClass from 'create-react-class';

import NoteConstants from 'notebook/notes/NoteConstants';
import Col from 'ui-library/bs/Col';
import Row from 'ui-library/bs/Row';
import PreviewMixin from 'notebook/notes/previews/PreviewMixin';

const BasicFolderItemPreview = createReactClass({
  mixins: [PreviewMixin],

  className: 'note-BasicFolderItem',
  noteType: NoteConstants.BASIC_FOLDER_ITEM,

  renderAttr(name, value) {
    return (
      <div key={name} className="notePreview-bfiTag">
        <Row className="u-small-spacing-left">
          <Col sm={4}>
            <div className="u-faded">{name}</div>
          </Col>
          <Col sm={8}>{value}</Col>
        </Row>
      </div>
    );
  },

  renderItem() {
    return (
      <div className="note-preview-body">
        {Array.from(this.props.item.tags).map((tag) => this.renderAttr(tag.name, tag.value))}
      </div>
    );
  },
});

export default BasicFolderItemPreview;
